import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { spotFinder } from "../app/endpoints";
import axiosBaseQuerySpotfinder from "./axiosBaseQuerySpotfinder";

export const customerApi = createApi({
  reducerPath: "customerApi",
  baseQuery: axiosBaseQuerySpotfinder({
    baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL,
  }),
  tagTypes: ["customer"],
  endpoints: (builder) => ({
    saveCustomerDetail: builder.mutation({
      query: (body) => {
        return {
          url: spotFinder.customerDetailController.saveCustomerDetail,
          method: "POST",
          body: body.payload,
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),
    updateCustomerDetail: builder.mutation({
      query: (body) => {
        return {
          url: spotFinder.customerDetailController.updateCustomerDetail,
          method: "PUT",
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    findCustomerDetailByUserId: builder.mutation({
      query: (body) => {
        return {
          url: `${spotFinder.customerDetailController.findCustomerDetailByUserId}/${body.id}`,
          method: "GET",
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),
    findCustomerDetailById: builder.mutation({
      query: (body) => {
        return {
          url: `${spotFinder.customerDetailController.findCustomerDetailById}/${body.id}`,
          method: "GET",
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),

    uploadCustomerImage: builder.mutation({
      query: (body) => {
        return {
          url: `${spotFinder.customerDetailController.uploadCustomerImage}/${body.id}/${body.docType}`,
          method: "POST",
          headers: {
            Authorization: `Bearer ${body.token}`,
          },
          body: body.payload,
        };
      },
    }),
    deleteCustomerImage: builder.mutation({
      query: body => {
        return {
          url: `${spotFinder.customerDetailController.deleteCustomerImage}/${body.id}`,
          method: 'DELETE',
          headers: body.token ? { Authorization: `Bearer ${body.token}` } : {},
        };
      },
    }),
  }),
});


export const {
  useSaveCustomerDetailMutation,
  useUpdateCustomerDetailMutation,
  useFindCustomerDetailByIdMutation,
  useFindCustomerDetailByUserIdMutation,
  useUploadCustomerImageMutation,
  useDeleteCustomerImageMutation
} = customerApi;
